import styled from 'styled-components';

export const AppContainerStyled = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;
